import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function deleteToast(eventKey: string): RootActionTypes {
  return {
    type: ActionTypes.DELETE_TOAST,
    payload: { eventKey },
  };
}
